<template>
  <app-card
    v-bind="$attrs"
    class="v-card--material mt-4"
  >
    <v-card-title class="align-start">
      <v-sheet
        :color="color"
        :width="fullHeader ? '100%' : undefined"
        class="overflow-hidden mt-n9 transition-swing v-card--material__sheet"
        elevation="6"
        max-width="100%"
        rounded
      >
        <v-theme-provider
          v-if="hasHeading"
          dark
        >
          <div
            v-if="icon"
            :class="iconSmall ? 'pa-7' : 'pa-8'"
          >
            <v-icon
              :large="!iconSmall"
              v-text="icon"
            />
          </div>

          <slot name="heading" />

          <div
            v-if="heading"
            class="text-h4 white--text pa-7 v-card--material__title"
          >
            {{ heading }}
          </div>
        </v-theme-provider>
      </v-sheet>

      <div
        v-if="hasTitle"
        :class="fullHeader ? 'pt-4' : 'pl-3'"
        class="text-h4 v-card--material__title"
      >
        <slot name="title" />

        <div v-if="title" class="v-card--material__title-text">
          {{ title }}
        </div>

        <div class="text-subtitle-1 mb-n4">
          <slot name="subtitle" />

          <template v-if="subtitle">
            {{ subtitle }}
          </template>
        </div>
      </div>
    </v-card-title>

    <slot />

    <template v-if="$slots.actions">
      <v-divider class="mt-2 mx-4" />

      <v-card-actions class="px-4 text-caption grey--text">
        <slot name="actions" />
      </v-card-actions>
    </template>
  </app-card>
</template>

<script>
  export default {
    name: 'MaterialCard',

    props: {
      color: String,
      fullHeader: Boolean,
      heading: String,
      icon: String,
      iconSmall: Boolean,
      subtitle: String,
      title: String,
    },

    computed: {
      hasHeading () {
        return !!(
          this.icon ||
          this.heading ||
          this.$slots.heading
        )
      },
      hasTitle () {
        return !!(
          this.title ||
          this.subtitle ||
          this.$slots.title ||
          this.$slots.subtitle
        )
      },
    },
  }
</script>

<style lang="sass">
  .v-card.v-card--material
    > .v-card__title
      > .v-card--material__title
        flex: 1 1 auto
        min-width: 0
        word-break: break-word

  // Stat cards: allow long titles to wrap nicely
  .v-card--material-stats.v-card--material
    > .v-card__title
      align-items: flex-start
      flex-wrap: nowrap

    // Reserve horizontal space for the floating icon sheet so long titles
    // don't render underneath it (especially when right-aligned).
    .v-card--material__sheet
      flex: 0 0 auto

    > .v-card__title > .v-card--material__title:not(:first-child)
      padding-left: 8px
      box-sizing: border-box

    .v-card--material__title
      white-space: normal
      overflow-wrap: anywhere
      word-break: break-word
      line-height: 1.2

    .v-card--material__title-text
      font-size: .9rem !important
      font-weight: 400
      overflow: hidden
      white-space: normal
      display: -webkit-box
      -webkit-line-clamp: 2
      -webkit-box-orient: vertical
      width: 100%
      text-align: right

    @media (max-width: 960px)
      > .v-card__title > .v-card--material__title:not(:first-child)
        max-width: calc(100% - 92px)

    @media (max-width: 600px)
      .v-card--material__title
        font-size: 1.1rem !important
      .v-card--material__title-text
        font-size: .82rem !important
      > .v-card__title > .v-card--material__title:not(:first-child)
        max-width: calc(100% - 84px)

  // Mobile responsiveness: reduce header icon block dominance
  @media (max-width: 600px)
    .v-card--material__sheet
      margin-top: -24px !important

    .v-card--material__sheet > div
      padding: 16px !important

    .v-card--material__sheet .v-icon
      font-size: 28px !important
</style>
